import { graphql, useStaticQuery } from 'gatsby'
import { getLocalizedData } from 'Shared/utils/localeURL.ts'
const localizedConfigData = getLocalizedData(
  process.env.LOCALE,
  process.env.PROJECT
)

// TODO: We can/should not use this approach, because StaticQuery has no variables, we need to fetch all language variant data in layout query.
export const useHeaderData = () => {
  const {
    orchard: { menu },
  } = useStaticQuery(
    graphql`
      {
        orchard {
          menu(where: { alias: { alias_ends_with: "/header-navigation" } }) {
            displayText
            alias {
              alias
            }
            menuItemsList {
              menuItems {
                ... on Orchard_ContentMenuItem {
                  render
                  contentMenuItemCTA {
                    html
                  }
                  contentMenuItemDuplicateAlias
                  menuItemsList {
                    menuItems {
                      ... on Orchard_PuxMegamenuCategoryItem {
                        categoryItemDescription
                        categoryItemName
                        menuItemsList {
                          menuItems {
                            ... on Orchard_ContentMenuItem {
                              contentMenuItemDuplicateAlias
                              contentMenuItemDuplicateMainItem
                              contentMenuItemDuplicateHide
                              contentType
                              render
                            }
                            ... on Orchard_LinkMenuItem {
                              contentType
                              linkMenuItem {
                                name
                                url
                              }
                            }
                            ... on Orchard_HtmlMenuItem {
                              htmlMenuItem {
                                html
                                url
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    `
  )

  var languageMenu = menu.filter(
    (m) => m.alias.alias.indexOf(localizedConfigData.isoCode) === 0
  )

  return languageMenu && languageMenu.length
    ? languageMenu[0].menuItemsList
    : menu[0].menuItemsList
}
